define('home/models/activities/MentionActivity',[
    'home/models/Activity',
    'home/activityExpander',
], function (
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * Activity for a user mentioning another user in a post.
     *
     * @class MentionActivity
     * @augments Activity
     *
     * @property {User} actor - The user that mentioned another user in a post.
     * @property {User} object - The user which was mentioned.
     * @property {Post} target - The comment in which the mention occured.
     * @property {Thread} thread - The thread that the post belongs to.
     */
    return Activity.extend({
        defaults: {
            verb: 'mention',
        },

        initialize: function (attributes) {
            this.actor = attributes.actor;
            this.object = attributes.object;
            this.target = attributes.target;
            this.thread = attributes.target.thread;
        },

        parseRelatedModels: function (attributes, objects) {
            attributes.object = activityExpander.buildUser(objects, attributes.object);
            attributes.actor = activityExpander.buildUser(objects, attributes.actor);
            attributes.target = activityExpander.buildPost(objects, attributes.target);

            return attributes;
        },
    });
});

